/**
 * Validated Mexican postal code value object (5 digits)
 */
export type PostalCode = Readonly<string>;

/**
 * Creates a validated PostalCode value object.
 *
 * @param raw - Raw postal code string
 * @returns Validated PostalCode
 * @throws Error if format is not a valid Mexican postal code
 */
export const createPostalCode = (raw: string): PostalCode => {
  if (!/^\d{5}$/.test(raw)) {
    throw new Error('Postal code must be exactly 5 digits');
  }
  return raw as PostalCode;
};
